import { Link } from "react-router-dom";

const columns = [
  {
    title: "浏览",
    links: [
      { label: "首页", to: "/" },
      { label: "电影分类", to: "/category" },
      { label: "剧情解析", to: "/features/plot-analysis" },
      { label: "观影指南", to: "/guides" },
    ],
  },
  {
    title: "内容",
    links: [
      { label: "影片详情", to: "/detail/tao-1997" },
      { label: "演员介绍", to: "/actors/li-lizhen" },
      { label: "最新资讯", to: "/guides" },
      { label: "关于我们", to: "/about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-background-100 mt-16 md:mt-24">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-semibold text-background-50">
                蜜桃成熟时1997影视内容站
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-100/75 max-w-md">
              我们专注于九十年代经典亚洲电影的资料整理与深度解析，为影迷、研究者与普通观众提供电影介绍、剧情解析、演员资料与观影指南。站内内容均为示范演示数据，不含播放、下载与付费功能。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <span className="w-9 h-9 rounded-full bg-secondary-800 flex items-center justify-center text-background-100/80">
                <i className="ri-mail-line"></i>
              </span>
              <a
                href="mailto:hello@tao1997.example.com"
                className="text-sm text-background-100/80 hover:text-primary-300 transition-colors"
              >
                hello@tao1997.example.com
              </a>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="font-heading text-base font-semibold text-background-50 mb-4">
                {column.title}
              </h4>
              <ul className="space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-background-100/75 hover:text-primary-300 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">
            © 2026 蜜桃成熟时1997影视内容站 · 本站为影视内容演示站点，数据均为虚构示范
          </p>
          <p className="text-xs text-background-100/60">
            仅提供影片介绍与解析，不提供播放与下载服务
          </p>
        </div>
      </div>
    </footer>
  );
}